<template>
  <ValidationObserver ref="observer" v-slot="{ invalid, passes }">
    <b-modal
      id="edit_modal"
      ref="modal"
      title="Payment Details"
      :busy="loading"
    >
    <p><span class="font-weight-bold">Plan Name:</span>  {{ mainPlan.name }}</p>
    <p><span class="font-weight-bold">Amount:</span>  {{ uppercaseCurrency }} {{ purchase.amount }}</p>
    <p><span class="font-weight-bold">Description</span>:  {{ purchase.description }}</p>
    <p><span class="font-weight-bold">Due Date</span>:  {{ purchase.due_date }}</p>
    <p><span class="font-weight-bold">Billing Cycle</span>:  {{ purchase.billing_cycle }}</p>

    <b-form class="form" @submit.prevent="passes(doSubmit)">
        <p class="text-danger" v-if="errors.phone">
          {{ errors.phone[0] }}
        </p>

        <validation-provider
          name="PaymentMethod"
          rules="required"
          v-slot="{ errors }"
        >
        <div class="form-group">
          <label for="paymentMethod">Select Payment Method:</label>
          <b-form-select v-model="selectedPaymentMethod" id="paymentMethod">
            <option value="">Select Payment</option>
            <option :value="paymentMethod.channel" v-for="paymentMethod in paymentMethods" :key="paymentMethod.value">
              {{ paymentMethod.label }}
            </option>
          </b-form-select>
        </div>
        <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>

        <div v-if="selectedPaymentMethod === 'mtnMobileMoney' && selectedPaymentMethod !== ''"  class="payment-option">
          <label for="phoneNumber">Enter Phone Number Ghana Only:</label>

        <validation-provider
          name="phone"
          rules="required|digits:10"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <input
            class="form-control"
            placeholder="Enter MTN Mobile Number"
            v-model="phone"
            >
          </div>

          <span class="text-danger">{{ errors[0] }}</span>
        </validation-provider>
        </div>
      </b-form>

      <template v-slot:modal-footer>
        <b-button
          variant="info"
          type="submit"
          @click="doSubmit"
          :disabled="invalid || loading || !onLine"
        >
          {{ loading? 'Loading..': 'Pay' }}
        </b-button>
      </template>
    </b-modal>
    <payment-process-modal ref="paymentProcesssModal"></payment-process-modal>

  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

import { mapState } from "vuex";
import PaymentProcessModal from '@/components/PaymentProcessModal.vue';

import ApiService from "@/plugins/ApiService";

import { VueTelInput } from "vue-tel-input";
require("vue-tel-input/dist-modern/vue-tel-input.css");

export default {
  name: "PaymentDetailModal",

  components: {
    ValidationObserver,
    ValidationProvider,
    VueTelInput,
    PaymentProcessModal
  },

  data() {
    return {
      phone: null,
      transaction_id: null,
      formattedPhone:null,
      invoice_id : null,
      selectedPaymentMethod: '',
      selectedProvider: '',
      paymentMethods: [
        { label: 'Credit Card', channel: 'creditcard', provider: 'orchard' },
       // { label: 'MTN Mobile Money', channel: 'mtnMobileMoney', provider: 'mtn' },
         { label: 'Mobile Money', channel: 'vodafoneCash', provider: 'orchard' },
         //{ label: 'AirtelTigo Cash', channel: 'airtelTigoCash', provider: 'orchard' },
      ],
    }
  },

  computed: {
    ...mapState({
      errors: (state) => state.errors,
      loading: (state) => state.loading,
      onLine: (state) => state.auth.onLine,
    }),
    uppercaseCurrency() {
      return this.purchase?.currency?.toUpperCase();
    },
  },

  watch: {
    selectedPaymentMethod() {
      const selectedMethod = this.paymentMethods.find(method => method.channel === this.selectedPaymentMethod);
      this.selectedProvider = selectedMethod ? selectedMethod.provider : '';

    },
  },

  mounted(){
    const phone = this.getAyoba()?.getMsisdn();
    this.phone = phone ? "0" + phone.substring(4) : null;

  },

 

  methods: {
    create(invoiceId = null) {
      this.invoice_id = invoiceId;
      this.$refs.modal.show();
    },

    formatPhone() {
      const cleanedPhone = this.phone ? this.phone.replace(/^0+/, "") : null;
      this.formattedPhone = cleanedPhone? `233${cleanedPhone}` : null;
    },

    
    makePayment() {
      this.formatPhone()

      return ApiService.axios( false, 'settings/pay-subscription', 
      {purchase_id: this.purchase?.id,
        momo_number: this.formattedPhone,
        invoice_id: this.invoice_id,
        channel: this.selectedPaymentMethod,
        provider: this.selectedProvider
      })
    },

    doSubmit() {

      this.makePayment()
        .then((data) => {

          // console.log(data);
          // console.log(data.data.payment_link);
          // console.log(data.data.transaction_id);

          if (data.data.payment_link != null) {
            location.href = data.data.payment_link
          } else {


          this.transaction_id = data.data.transaction_id
          this.$refs.modal.hide();
          this.$refs.paymentProcesssModal.create(this.transaction_id, this.selectedProvider, this.selectedPaymentMethod)

          }
        })
        .catch((error) => {
          console.log(error);
          this.$refs.observer.setErrors(this.errors);

          
        })

    },
  },
};
</script>


<style scoped>
/* Add your custom styles here */
.form-group {
  margin-bottom: 15px;
}

.payment-option {
  margin-bottom: 15px;
}

/* Style your modal and other elements as needed */
</style>